(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brick-osfe', {
            parent: 'entity',
            url: '/brick-osfe?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brickOsfe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick-osfe/brick-osfes.html',
                    controller: 'BrickOsfeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brickOsfe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brick-osfe-detail', {
            parent: 'entity',
            url: '/brick-osfe/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.brickOsfe.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-detail.html',
                    controller: 'BrickOsfeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brickOsfe');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrickOsfe', function($stateParams, BrickOsfe) {
                    return BrickOsfe.get({id : $stateParams.id});
                }]
            }
        })
        .state('brick-osfe.new', {
            parent: 'brick-osfe',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-dialog.html',
                    controller: 'BrickOsfeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaName: null,
                                territoryName: null,
                                codeGroup: null,
                                code: null,
                                postalCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('brick-osfe');
                });
            }]
        })
        .state('brick-osfe.edit', {
            parent: 'brick-osfe',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-dialog.html',
                    controller: 'BrickOsfeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrickOsfe', function(BrickOsfe) {
                            return BrickOsfe.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brick-osfe.delete', {
            parent: 'brick-osfe',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brick-osfe/brick-osfe-delete-dialog.html',
                    controller: 'BrickOsfeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrickOsfe', function(BrickOsfe) {
                            return BrickOsfe.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brick-osfe', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
